import { SettingOutlined } from '@ant-design/icons';
import { Button, Dropdown, type MenuProps } from 'antd';
import type React from 'react';
import { useNavigate } from 'react-router';
import { getItems } from '@/components/antd-layout/components/header/components/rbac/lib/utils.ts';
import { menuConfig } from './lib/constants';
import styles from './Rbac.module.css';

const Rbac: React.FC = () => {
  const navigate = useNavigate();

  const items: MenuProps['items'] = getItems(menuConfig(navigate));

  if (!items?.length) {
    return null;
  }

  return (
    <Dropdown menu={{ items }} trigger={['click', 'hover']} placement="bottomLeft" rootClassName={styles.wrapper}>
      <Button shape="round" icon={<SettingOutlined />} />
    </Dropdown>
  );
};

export default Rbac;
